import { SnipesApp } from "./model/SnipesApp";

export const useSnipesApp = ()=>{
    return (window as any).SnipesApp as SnipesApp;
}